import angular from 'angular';

angular.module('cloudX').directive('updateOnEnter', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {
      element.on('keyup', function(ev) {
        if (ev.keyCode == 13) {
          ctrl.$commitViewValue();
          scope.$apply(ctrl.$setTouched);
        }
      });
    },
  };
});
